import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../firebase";
import { FIREBASE_COLLECTIONS } from "../config/firebaseCollections";
import {
  ENGAGEMENT_EVENT_TYPE_SET,
  ENGAGEMENT_PLATFORMS,
  FEATURE_EVENT_TYPES,
  normalizeEventType,
} from "../config/engagementEvents";

const APP_VERSION = process.env.REACT_APP_VERSION || "unknown";

let cachedSchoolId = null;
let cachedSchoolIdUid = null;

function detectPlatform() {
  if (typeof window === "undefined") {
    return ENGAGEMENT_PLATFORMS.DESKTOP;
  }

  const ua = navigator.userAgent || "";
  const isMobile = /Mobi|Android/i.test(ua);
  const isTablet = /Tablet|iPad/i.test(ua) || (navigator.maxTouchPoints > 1 && window.innerWidth >= 768);

  if (isTablet) return ENGAGEMENT_PLATFORMS.TABLET;
  if (isMobile) return ENGAGEMENT_PLATFORMS.MOBILE;
  return ENGAGEMENT_PLATFORMS.DESKTOP;
}

let activeSessionId = null;
let activeSessionStartedAtMs = 0;

export function getEngagementSessionId() {
  return activeSessionId;
}

export function getEngagementSessionStartedAt() {
  return activeSessionStartedAtMs ? new Date(activeSessionStartedAtMs) : null;
}

export function setEngagementSessionId(sessionId, startedAt = Date.now()) {
  activeSessionId = sessionId || null;
  activeSessionStartedAtMs = sessionId ? Number(startedAt) || Date.now() : 0;
}

export function setEngagementSchoolId(schoolId, uid) {
  cachedSchoolId = schoolId || null;
  cachedSchoolIdUid = uid || null;
}

export async function logEngagementEvent(eventType, metadata = {}) {
  const normalizedType = normalizeEventType(eventType);
  if (!ENGAGEMENT_EVENT_TYPE_SET.has(eventType) && !ENGAGEMENT_EVENT_TYPE_SET.has(normalizedType)) {
    console.warn(`Unknown engagement event type: ${eventType}`);
    return;
  }

  const uid = metadata.uid || auth.currentUser?.uid;
  if (!uid) {
    return;
  }

  const schoolId = metadata.schoolId
    ?? (cachedSchoolIdUid === uid ? cachedSchoolId : null);

  const payload = {
    uid,
    schoolId,
    eventType: normalizedType,
    timestamp: serverTimestamp(),
    metadata: metadata.payload || {},
    sessionId: metadata.sessionId ?? activeSessionId ?? null,
    classId: metadata.classId ?? null,
    platform: metadata.platform || detectPlatform(),
    version: APP_VERSION,
  };

  try {
    await addDoc(collection(db, FIREBASE_COLLECTIONS.EVENTS), payload);
  } catch (error) {
    console.warn("Failed to write behavior event:", error);
  }
}

export function trackEngagementFeature(featureKey, metadata = {}) {
  const eventType = FEATURE_EVENT_TYPES[featureKey];
  if (!eventType) {
    return;
  }

  logEngagementEvent(eventType, metadata);
}
